import axios from '@/libs/api.request'

export const page = (data) => {
  return axios.request({
    url: '/ad/settlement/page',
    method: 'get',
    params: data
  })
}

export const detail = (id) => {
  return axios.request({
    url: `/ad/settlement/detail/${id}`,
    method: 'get'
  })
}

export const syncData = () => {
  return axios.request({
    url: '/ad/settlement/syncData',
    method: 'post'
  })
}


// WEBPACK FOOTER //
// ./src/api/ad-settlement.js